import {COMPANIES_AUTOCOMPLETE_LOADING, COMPANIES_AUTOCOMPLETE_UPDATE} from "../actions/companyAutocompleteActions";

const INITIAL_STATE = {
  companies: {},
  loading: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case COMPANIES_AUTOCOMPLETE_UPDATE:
      const companies = {...state.companies, [action.id]: action.payload.data};
      return {
        ...state,
        companies: companies,
      };
    case COMPANIES_AUTOCOMPLETE_LOADING:
      const loading = {...state.loading, [action.id]: action.payload};
      return {
        ...state,
        loading: loading,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/company/reducers/CompanyAutocompleteReducer.js